import { createSelector } from '@reduxjs/toolkit';
import type { EmployeeViewModel } from '@trinnvis/dabih-api-client';
import { getEmployeesById } from './get-employees-by-id';
import { toList } from '../toList';

export const getEmployees = createSelector(getEmployeesById, (employeesById): EmployeeViewModel[] =>
  toList(employeesById),
);
